<template>
    <div>
        <el-button type="primary" @click="addBtn()">新增字段</el-button>
        <el-dialog title="新增字段" center :visible.sync="dialogVisible" width="70%">
            <el-card class="box-card" style="width: 80%;margin-left: 10%;min-height: 15.0rem;margin-top: 1.0rem;">
                <div>
                    <el-input placeholder="请输入字段名" v-model="inputA" clearable style="width: 55%;margin-right: 15px">
                    </el-input>
                    <el-switch v-model="required" inactive-text="是否必填" style="margin-right: 1.0rem">
                    </el-switch>
                    <el-switch v-model="isShow" inactive-text="是否显示">
                    </el-switch>
                    <el-select v-model="value" placeholder="请选择" style="width: 18%;float:right;">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div style="width: 100%;height: 0;margin-top:5px;border: solid 0.5px lightgrey"></div>
                <div v-if="value == 'input'" style="color: grey;margin-top: 2.0rem;">
                    待填写者写入文本
                </div>
                <div v-if="value == 'number'" style="color: grey;margin-top: 2.0rem;">
                    待填写者写入数字
                </div>
                <div class="radio" v-if="value == 'radio'" style="color: grey;margin-top: 2.0rem;">
                    <div v-for="(j, ind) in radionum" :key="ind">
                        <el-input placeholder="请输入选项名" v-model="radioname[ind]" clearable style="width: 80%;">
                        </el-input>
                    </div>
                    <div>
                        <el-button type="text" @click="addradio(j)"><i class="el-icon-circle-plus-outline"
                                style="font-size: 2.0rem;margin-top: 1.0rem"></i></el-button>
                        <el-button type="text" @click="deleteradio(j)"><i class="el-icon-remove-outline"
                                style="font-size: 2.0rem;margin-top: 1.0rem"></i></el-button>
                    </div>
                </div>
                <div class="radio" v-if="value == 'checkbox'" style="color: grey;margin-top: 2.0rem;">
                    <div v-for="(j, ind) in checkboxnum" :key="ind">
                        <el-input placeholder="请输入选项名" v-model="checkboxname[ind]" clearable style="width: 80%;">
                        </el-input>
                    </div>
                    <div>
                        <el-button type="text" @click="addcheckbox(i)"><i class="el-icon-circle-plus-outline"
                                style="font-size: 2.0rem;margin-top: 1.0rem"></i></el-button>
                        <el-button type="text" @click="deletecheckbox(i)"><i class="el-icon-remove-outline"
                                style="font-size: 2.0rem;margin-top: 1.0rem"></i></el-button>
                    </div>
                </div>
                <div class="radio" v-if="value == 'select'" style="color: grey;margin-top: 2.0rem;">
                    <div v-for="(j, ind) in selectnum" :key="ind">
                        <el-input placeholder="请输入选项名" v-model="selectname[ind]" clearable style="width: 80%;">
                        </el-input>
                    </div>
                    <div>
                        <el-button type="text" @click="addselect(i)"><i class="el-icon-circle-plus-outline"
                                style="font-size: 2.0rem;margin-top: 1.0rem"></i></el-button>
                        <el-button type="text" @click="deleteselect(i)"><i class="el-icon-remove-outline"
                                style="font-size: 2.0rem;margin-top: 1.0rem"></i></el-button>
                    </div>
                </div>
                <div class="radio" v-if="value == 'DatePicker'" style="color: grey;margin-top: 2.0rem;">
                    待填写者选择时间
                </div>
                <div class="radio" v-if="value == 'upload'" style="color: grey;margin-top: 2.0rem;">
                    <el-radio v-model="imgF" label="image">图片</el-radio>
                    <el-radio v-model="imgF" label="file">文件</el-radio>
                </div>
            </el-card>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleAdd()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="修改字段" center :visible.sync="dialogVisibleX" width="70%">
            <el-card class="box-card" style="width: 80%;margin-left: 10%;min-height: 15.0rem;margin-top: 1.0rem;"
                v-for="i in eForm" :key="i">
                <div>
                    <el-button type="text" style="padding: 8px !important; float: right;" @click="handleDelete(i)"><i
                            class="el-icon-circle-close" style="font-size: 2.0rem;color: #F56C6C"></i></el-button>
                    <el-button type="text" style="padding: 8px !important; float: right;" @click="handleEdit(i)"><i
                            class="el-icon-edit" style="font-size: 2.0rem;"></i></el-button>
                </div>
                <div>
                    <el-input placeholder="请输入字段名" v-model="i.title" clearable style="width: 45%;margin-right: 15px"
                        :disabled="i.disabled">
                    </el-input>
                    <el-switch v-model="i.required" inactive-text="是否必填" style="margin-right: 1.0rem" :disabled="i.disabled">
                    </el-switch>
                    <el-switch v-model="i.if_show" inactive-text="是否显示" :disabled="i.disabled">
                    </el-switch>
                    <el-select v-model="i.type" placeholder="请选择" style="width: 18%;float:right;" :disabled="i.disabled">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div style="width: 100%;height: 0;margin-top:5px;border: solid 0.5px lightgrey"></div>
                <div v-if="i.type == 'input'" style="color: grey;margin-top: 2.0rem;" :disabled="i.disabled">
                    待填写者写入文本
                </div>
                <div v-if="i.type == 'number'" style="color: grey;margin-top: 2.0rem;" :disabled="i.disabled">
                    待填写者写入数字
                </div>
                <div class="radio" v-if="i.type == 'radio'" style="color: grey;margin-top: 2.0rem;">
                    <div v-for="(j, ind) in i.options" :key="ind">
                        <el-input placeholder="请输入选项名" v-model="j.value" clearable style="width: 80%;"
                            :disabled="i.disabled">
                        </el-input>
                    </div>
                    <div v-if="!i.disabled">
                        <el-button type="text" @click="addO(i)"><i class="el-icon-circle-plus-outline"
                                style="font-size: 2.0rem;margin-top: 1.0rem"></i></el-button>
                        <el-button type="text" @click="delO(i)"><i class="el-icon-remove-outline"
                                style="font-size: 2.0rem;margin-top: 1.0rem"></i></el-button>
                    </div>
                </div>
                <div class="radio" v-if="i.type == 'checkbox'" style="color: grey;margin-top: 2.0rem;">
                    <div v-for="(j, ind) in i.options" :key="ind">
                        <el-input placeholder="请输入选项名" v-model="j.value" clearable style="width: 80%;"
                            :disabled="i.disabled">
                        </el-input>
                    </div>
                    <div v-if="!i.disabled">
                        <el-button type="text" @click="addO(i)"><i class="el-icon-circle-plus-outline"
                                style="font-size: 2.0rem;margin-top: 1.0rem"></i></el-button>
                        <el-button type="text" @click="delO(i)"><i class="el-icon-remove-outline"
                                style="font-size: 2.0rem;margin-top: 1.0rem"></i></el-button>
                    </div>
                </div>
                <div class="radio" v-if="i.type == 'select'" style="color: grey;margin-top: 2.0rem;">
                    <div v-for="(j, ind) in i.options" :key="ind">
                        <el-input placeholder="请输入选项名" v-model="j.value" clearable style="width: 80%;"
                            :disabled="i.disabled">
                        </el-input>
                    </div>
                    <div v-if="!i.disabled">
                        <el-button type="text" @click="addO(i)"><i class="el-icon-circle-plus-outline"
                                style="font-size: 2.0rem;margin-top: 1.0rem"></i></el-button>
                        <el-button type="text" @click="delO(i)"><i class="el-icon-remove-outline"
                                style="font-size: 2.0rem;margin-top: 1.0rem"></i></el-button>
                    </div>
                </div>
                <div class="radio" v-if="i.type == 'DatePicker'" style="color: grey;margin-top: 2.0rem;"
                    :disabled="i.disabled">
                    待填写者选择时间
                </div>
                <div class="radio" v-if="i.type == 'upload'" style="color: grey;margin-top: 2.0rem;" :disabled="i.disabled">
                    <el-radio v-model="i.props.uploadType" disabled label="image">图片</el-radio>
                    <el-radio v-model="i.props.uploadType" disabled label="file">文件</el-radio>
                </div>
            </el-card>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleX = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisibleX = false, sureEdit()">确 定</el-button>
            </span>
        </el-dialog>
        <form-create v-model="yulanform" :rule="formrule" :option="option" @on-submit="onSubmit1"
            style="width: 80%;margin-top: 2.0rem;pointer-events: none;"></form-create>

        <div style="text-align: center;">
            <el-button type="primary" @click="edit()">修改</el-button>
            <el-button type="primary" @click="submitForm()">提交</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "selfField",
    props: {
        state: {
            type: String,
            default: "leads",
        },
    },
    data() {
        return {
            dialogVisible: false,
            dialogVisibleX: false,
            inputA: "",  //新增
            inputE: "",  //修改
            options: [{    //下拉选择框
                value: 'input',
                label: '文本'
            }, {
                value: 'number',
                label: '数值'
            }, {
                value: 'radio',
                label: '单选按钮'
            }, {
                value: 'checkbox',
                label: '多选按钮'
            }, {
                value: 'select',
                label: '下拉选择'
            }, {
                value: 'DatePicker',
                label: '日期'
            },
            {
                value: 'upload',
                label: '文件'
            }],
            value: "",   //选择的字段类型值
            required: true,  //是否必填字段
            isShow: true,   //是否显示字段
            radionum: 2,  //单选按钮的选项个数
            radioname: [],   //单选按钮名字
            checkboxnum: 2,   //多选按钮的选项个数
            checkboxname: [],   //多选按钮名字
            selectnum: 2,   //下拉框的选项个数
            selectname: [],   //下拉框名字
            yulanform: {},   //表单实例对象
            option: {
                submitBtn: {
                    show: false,
                },
            },
            formrule: [],   //生成的表单规则,
            eForm: [],   //修改弹框的表单规则数据
            action: "https://api.weijub.com/api/Alioss/uploadTotal",
            custom_field: [],   //后端返的带有键的对象
            fie: [],   //存储的键
            selfSub: {},   //数据更改之后组合键与值的数据
            remark: [],   //已经存在自定义字段时，新增字段存储位置
            imgF: "",   //上传类型为upload时，选择上传图片或文件
            acceptI: ".jpg, .png",
            acceptF: ".mp4, .xls, .pdf, .doc, .docx"
        }
    },
    watch: {
        state() {
            this.formrule = []
            this.eForm = []
            this.getData()
        }
    },
    mounted() {
        this.formrule = []
        this.eForm = []
        this.getData()
    },
    methods: {
        //增加单选按钮选项，实时更新数组用$set
        addradio() {
            this.radionum += 1
        },
        deleteradio() {
            this.radionum -= 1
        },
        //增加多选按钮选项
        addcheckbox() {
            this.checkboxnum += 1
        },
        deletecheckbox() {
            this.checkboxnum -= 1
        },
        //增加下拉框选项
        addselect() {
            this.selectnum += 1
        },
        deleteselect() {
            this.selectnum -= 1
        },
        // 新增数据
        handleAdd() {
            if (this.value == '') {
                this.$message.error('请选择字段类型')
            } else if (this.inputA == '') {
                this.$message.error('请填写字段名称')
            } else {
                if (this.value == 'radio') {
                    this.dialogVisible = false
                    let h = (this.radioname.length)
                    let options = [];
                    for (let j = 0; j < h; j++) {
                        options.push(
                            { value: this.radioname[j], label: this.radioname[j] },
                        )
                    }
                    this.formrule.push({
                        type: this.value,
                        field: this.inputA,
                        title: this.inputA,
                        required: this.required,
                        display: true,
                        if_show: this.isShow,
                        disabled: true,
                        options: options,
                        value: "",
                        validate: [{ type: "string", required: this.required, message: "请选择" }],
                    },)
                    this.remark.push({
                        type: this.value,
                        field: this.inputA,
                        title: this.inputA,
                        required: this.required,
                        display: true,
                        if_show: this.isShow,
                        disabled: true,
                        options: options,
                        value: "",
                        validate: [{ type: "string", required: this.required, message: "请选择" }],
                    })
                } else if (this.value == 'checkbox') {
                    this.dialogVisible = false
                    let h = (this.checkboxname.length)//3
                    let options = [];
                    for (let j = 0; j < h; j++) {
                        options.push(
                            { value: this.checkboxname[j], label: this.checkboxname[j] },
                        )
                    }
                    this.formrule.push({
                        type: this.value,
                        field: this.inputA,
                        title: this.inputA,
                        options: options,
                        required: this.required,
                        display: true,
                        if_show: this.isShow,
                        disabled: true,
                        value: [],
                        validate: [{ type: "array", min: 1, required: this.required, message: "请选择" }],
                    })
                    this.remark.push({
                        type: this.value,
                        field: this.inputA,
                        title: this.inputA,
                        options: options,
                        required: this.required,
                        display: true,
                        if_show: this.isShow,
                        disabled: true,
                        value: [],
                        validate: [{ type: "array", min: 1, required: this.required, message: "请选择" }],
                    })

                } else if (this.value == 'select') {
                    this.dialogVisible = false
                    let h = (this.selectname.length)//3
                    let options = [];
                    let opt = [];
                    for (let j = 0; j < h; j++) {
                        options.push(
                            { value: this.selectname[j], label: this.selectname[j] },
                        )
                        opt.push(
                            { text: this.selectname[j], value: this.selectname[j] },
                        )
                    }
                    this.formrule.push({
                        type: this.value,
                        field: this.inputA,
                        title: this.inputA,
                        options: options,
                        opt: opt,
                        required: this.required,
                        display: true,
                        if_show: this.isShow,
                        disabled: true,
                        value: "",
                        validate: [{ type: "string", required: this.required, message: "请选择" }],
                    },)
                    this.remark.push({
                        type: this.value,
                        field: this.inputA,
                        title: this.inputA,
                        options: options,
                        opt: opt,
                        required: this.required,
                        display: true,
                        if_show: this.isShow,
                        disabled: true,
                        value: "",
                        validate: [{ type: "string", required: this.required, message: "请选择" }],
                    },)
                } else if (this.value == 'upload') {
                    if (this.imgF == '') {
                        this.$message.error('请选择上传类型')
                    } else {
                        this.dialogVisible = false
                        if (this.imgF == 'image') {
                            this.formrule.push({
                                type: this.value,
                                field: this.inputA,
                                title: this.inputA,
                                value: [],
                                required: this.required,
                                display: true,
                                if_show: this.isShow,
                                disabled: true,
                                fileList: [],
                                validate: [{ type: "string", required: this.required, message: "请上传" }],
                                props: {
                                    type: "select",
                                    uploadType: this.imgF,
                                    action: this.action,
                                    name: "file",
                                    multiple: true,
                                    accept: this.acceptI,
                                    limit: 6,
                                },
                            },)
                            this.remark.push({
                                type: this.value,
                                field: this.inputA,
                                title: this.inputA,
                                value: [],
                                required: this.required,
                                display: true,
                                if_show: this.isShow,
                                disabled: true,
                                fileList: [],
                                validate: [{ type: "string", required: this.required, message: "请上传" }],
                                props: {
                                    type: "select",
                                    uploadType: this.imgF,
                                    action: this.action,
                                    name: "file",
                                    multiple: true,
                                    accept: this.acceptI,
                                    limit: 6,
                                },
                            },)
                        } else {
                            this.formrule.push({
                                type: this.value,
                                field: this.inputA,
                                title: this.inputA,
                                value: [],
                                required: this.required,
                                display: true,
                                if_show: this.isShow,
                                disabled: true,
                                fileList: [],
                                validate: [{ type: "string", required: this.required, message: "请上传" }],
                                props: {
                                    type: "select",
                                    uploadType: this.imgF,
                                    action: this.action,
                                    name: "file",
                                    multiple: true,
                                    accept: this.acceptF,
                                    limit: 6,
                                },
                            },)
                            this.remark.push({
                                type: this.value,
                                field: this.inputA,
                                title: this.inputA,
                                value: [],
                                required: this.required,
                                display: true,
                                if_show: this.isShow,
                                disabled: true,
                                fileList: [],
                                validate: [{ type: "string", required: this.required, message: "请上传" }],
                                props: {
                                    type: "select",
                                    uploadType: this.imgF,
                                    action: this.action,
                                    name: "file",
                                    multiple: true,
                                    accept: this.acceptF,
                                    limit: 6,
                                },
                            },)
                        }

                    }
                } else if (this.value == 'number') {
                    this.dialogVisible = false
                    this.formrule.push({
                        type: this.value,
                        field: this.inputA,
                        title: this.inputA,
                        required: this.required,
                        display: true,
                        if_show: this.isShow,
                        disabled: true,
                        value: "",
                        validate: [{ type: "number", required: this.required, message: "请填写" }],
                    },)
                    this.remark.push({
                        type: this.value,
                        field: this.inputA,
                        title: this.inputA,
                        required: this.required,
                        display: true,
                        if_show: this.isShow,
                        disabled: true,
                        value: "",
                        validate: [{ type: "number", required: this.required, message: "请填写" }],
                    },)
                } else {
                    this.dialogVisible = false
                    this.formrule.push({
                        type: this.value,
                        field: this.inputA,
                        title: this.inputA,
                        required: this.required,
                        display: true,
                        if_show: this.isShow,
                        disabled: true,
                        value: "",
                        validate: [{ type: "string", required: this.required, message: "请填写" }],
                    },)
                    this.remark.push({
                        type: this.value,
                        field: this.inputA,
                        title: this.inputA,
                        required: this.required,
                        display: true,
                        if_show: this.isShow,
                        disabled: true,
                        value: "",
                        validate: [{ type: "string", required: this.required, message: "请填写" }],
                    },)
                }
            }
        },
        // 修改提交数据
        async sureEdit() {
            this.eForm.forEach((item) => {
                if (item.options.length) {
                    item.options.map((i) => {
                        if (i.label == '') {
                            return i.label = i.value
                        }
                    })
                }
            })
            if (this.eForm.length == 0) {
                this.selfSub = []
            } else {
                this.selfSub = {}
                for (let j = 0; j < this.eForm.length; j++) {
                    this.eForm[j].disabled = true
                    this.eForm[j].validate[0].required = this.eForm[j].required
                    this.$set(this.selfSub, this.eForm[j].field, this.eForm[j])
                }
            }

            const res = await this.axios({
                url: "/crm/ApplyExpense/custom_apply_filed",
                method: "POST",
                data: {
                    account_id: this.tooken.account_id,
                    state: this.state,
                    custom_field: JSON.stringify(this.selfSub)
                }
            })
            if (res.data.code == 1) {
                this.$message({
                    message: res.data.msg,
                    type: "success"
                })
                this.formrule = []
                this.eForm = []
                this.getData()
            } else {
                this.$message({
                    message: res.data.msg,
                    type: "error"
                })
            }
        },
        // 删除数据
        handleDelete(item) {
            // let array = JSON.parse(JSON.stringify(this.eForm))
            let index = this.eForm.findIndex((i) => {
                return i.field == item.field
            })
            this.eForm.splice(index, 1)
            if (this.eForm.length == 0) {
                this.selfSub = []
            } else {
                this.selfSub = {}
                for (let j = 0; j < this.eForm.length; j++) {
                    this.$set(this.selfSub, this.eForm[j].field, this.eForm[j])
                }
            }
        },
        // 是否可编辑
        handleEdit(item) {
            item.disabled = false
        },
        // 编辑字段时,处理单选、多选、下拉增加选项
        addO(item) {
            item.options.push(
                { value: "", label: "" },
            )
        },
        // 编辑字段时,处理单选、多选、下拉删除选项
        delO(item) {
            item.options.pop()
        },
        // form-create的提交事件
        onSubmit1(formData) {
            alert(JSON.stringify(formData));
        },
        // 修改按钮事件
        edit() {
            this.dialogVisibleX = true
        },
        // 新增完成提交数据
        async submitForm() {
            if (this.formrule.length == 0) {
                this.selfSub = []
            } else {
                this.fie = []
                for (let i in this.custom_field) {
                    this.fie.push(i)
                }
                this.selfSub = {}
                for (let i = 0; i < this.fie.length; i++) {
                    for (let j = 0; j < this.formrule.length; j++) {
                        if (this.formrule[j].field == this.fie[i]) {
                            this.formrule[j].disabled = true
                            this.$set(this.selfSub, this.formrule[j].field, this.formrule[j])
                        }
                    }
                }
            }

            const result = Object.assign(this.selfSub, this.remark)

            const res = await this.axios({
                url: "/crm/ApplyExpense/custom_apply_filed",
                method: "POST",
                data: {
                    account_id: this.tooken.account_id,
                    state: this.state,
                    custom_field: JSON.stringify(result)
                }
            })
            if (res.data.code == 1) {
                this.$message({
                    message: res.data.msg,
                    type: "success"
                })
                this.formrule = [];
                this.remark = [];
                this.eForm = [];
                this.getData()
            } else {
                this.$message({
                    message: res.data.msg,
                    type: "error"
                })
            }
        },
        // 获取字段数据
        async getData() {
            const res = await this.axios({
                url: "/crm/ApplyExpense/get_custom_filed",
                method: "POST",
                data: {
                    account_id: this.tooken.account_id,
                    state: this.state
                }
            })
            if (res.data.code == 1) {
                this.custom_field = res.data.data.custom_field;
                for (let i in this.custom_field) {
                    this.formrule.push(this.custom_field[i])
                    this.eForm.push(this.custom_field[i])
                }
            }
        },
        // 新增字段
        addBtn() {
            this.dialogVisible = true;
            this.clearData()
        },
        clearData() {
            this.inputA = "";
            this.value = "";
            this.required = true;
            this.isShow = true;
            this.radionum = 2;
            this.radioname = [];
            this.checkboxnum = 2;
            this.checkboxname = [];
            this.selectnum = 2;
            this.selectname = [];
            this.imgF = "";
        }
    }
}
</script>
  
<style>
.radio .el-input__inner {
    width: 22.0rem;
    border-top-width: .0rem;
    border-left-width: .0rem;
    border-right-width: .0rem;
    border-bottom-width: 1px;
    /*outline: medium;*/
}

.radio1 .el-input__inner {
    width: 100%;
    border-top-width: .0rem;
    border-left-width: .0rem;
    border-right-width: .0rem;
    border-bottom-width: 1px;
    /*outline: medium;*/
}

.textarea .el-textarea__inner {
    width: 100%;
    border-top-width: .0rem;
    border-left-width: .0rem;
    border-right-width: .0rem;
    border-bottom-width: 1px;
    /*outline: medium;*/
}
</style>